import { Controller, useFormContext } from 'react-hook-form';

import { AspirationQuestionBlock } from './AspirationQuestionBlock';
import { GROWTH_BLOCK_SURFACE_CONFIDENTIAL } from './careerAspirationStyles';
import { useCareerAspirationFormText } from './useCareerAspirationFormText';

import type { CareerAspirationFormValues } from './careerAspirationValidation';
import type { CareerAspirationQuestionProps } from './types';

import { ChoiceChips, toggleSingle } from '@/components/ChoiceChips/ChoiceChips';
import { DEPARTURE_RISKS } from '@/types/career-growth';

/** The manager's read of the risk that the employee leaves: the one confidential question. */
export const DepartureRiskQuestion = ({
    employeeFirstName,
    dataTestId,
}: CareerAspirationQuestionProps) => {
    const { t, optionsOf } = useCareerAspirationFormText();
    const { control } = useFormContext<CareerAspirationFormValues>();

    const question = t('performanceProfile.growth.aspiration.departureRisk', {
        name: employeeFirstName,
    });

    return (
        <AspirationQuestionBlock
            title={question}
            caption={t('performanceProfile.growth.aspiration.form.visibility')}
            className={GROWTH_BLOCK_SURFACE_CONFIDENTIAL}
            dataTestId={`${dataTestId}-departure-risk`}
        >
            <Controller
                name={'departureRisk'}
                control={control}
                render={({ field }) => (
                    <ChoiceChips
                        options={optionsOf(
                            DEPARTURE_RISKS,
                            (risk) =>
                                `performanceProfile.growth.aspiration.departureRiskOptions.${risk}`,
                        )}
                        selected={field.value ? [field.value] : []}
                        onToggle={(value) => field.onChange(toggleSingle(field.value, value))}
                        ariaLabel={question}
                        dataTestId={`${dataTestId}-risk`}
                    />
                )}
            />
        </AspirationQuestionBlock>
    );
};
